/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geozoomhint2Inputs */

const en_geozoomhint2 = /** @type {(inputs: Geozoomhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom in for finer areas.`)
};

const de_geozoomhint2 = /** @type {(inputs: Geozoomhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hineinzoomen für feinere Gebiete.`)
};

/**
* | output |
* | --- |
* | "Zoom in for finer areas." |
*
* @param {Geozoomhint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geozoomhint2 = /** @type {((inputs?: Geozoomhint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geozoomhint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geozoomhint2(inputs)
	return de_geozoomhint2(inputs)
});
export { geozoomhint2 as "geoZoomHint" }